module.exports = __webpack_public_path__ + "static/media/pen-square.46818ab8.svg";